class CartDrawer extends HTMLElement {
  constructor() {
    super();
    const makeThis = this;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    this.form = this.querySelector('#CartUpsell-Form');
    this.form.querySelector('[name=id]').disabled = false;
    this.cart = document.querySelector('cart-drawer');
    
    $(document).on('click','#CartUpsell-Form .upsell__product-button',function(){
      makeThis.addUpsellProduct('#CartUpsell-Form')
    });

    $(document).on('click','.product_upsell__module .upsell__product-button',function(){
      makeThis.addUpsellProduct('#productUpsell-Form')
    });

    $(document).on("click",".cart_addplus_product",function(e){
      const btn_this = $(this);
       makeThis.addUpsellBundleProduct(btn_this);
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

    addUpsellBundleProduct(e){
      const __this = this;

       $(e).addClass("btn--loading")
        var variant = $(e).attr("data-variant_id");
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: variant,
            sections: __this.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          },
          dataType: 'json', 
          success: function (data) { 
             $(e).removeClass("btn--loading")
            __this.renderContents(data);
             // cartDrawerProduct();
          } 
       });
    }
  
  addUpsellProduct(formId){
    $('.upsell__product-button').addClass('loading');
    const __this = this;
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var getFormis = document.querySelector(formId);
    const formData = new FormData(getFormis); 

    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.setActiveElement(document.activeElement);
    
    config.body = formData;    
    fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
        $('.upsell__product-button').removeClass('loading');
        __this.renderContents(response);
       // cartDrawerProduct();
       //  listIconsSlider();
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      $('.drawer').removeClass('is-empty');
    });
  }
  
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    document.querySelector('.drawer ').classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

$(document).on('click','#CartUpsell-Form .product-single__variants input[name="Version"],#productUpsell-Form .product-single__variants input[name="Version"]',function(){
  var selfThis = $(this);
  variantSelector(selfThis)
})

function variantSelector(selfThis) {
      var value = selfThis.val(),
         selectOption = selfThis.find('option[value="' + value + '"]').attr("selected", "selected"),
         getHtml = $('#upsellProductjson').html(),
         getJSonData = JSON.parse(getHtml),
         SelectedVal = value,
         getVariant = getJSonData.variants,
         parentsSelector = selfThis.parents('.upsell__productbox');
    selfThis.parents('form').find('input[name=id]').val(value);
    selfThis.find('option').removeAttr("selected");
  
      for (let index = 0; index < getVariant.length; index++) {
          if(SelectedVal == getVariant[index].id){
              parentsSelector.find('.upsell__product-image img').attr('src',getVariant[index].featured_image.src);
              parentsSelector.find('.price_wrapper span.money').html('$'+getVariant[index].price/100);

              // Custom lightbox js - m
              if(getVariant[index].option1 == 'RGB Lightbox with Remote'){
                $('.product_upsell__module .lightbox-key_points .rgb__lightbox-wrapper').addClass('active');
                $('.product_upsell__module .lightbox-key_points .white__lightbox-wrapper').removeClass('active');
              }else if(getVariant[index].option1 == 'Bright White Lightbox'){
                $('.product_upsell__module .lightbox-key_points .rgb__lightbox-wrapper').removeClass('active');
                $('.product_upsell__module .lightbox-key_points .white__lightbox-wrapper').addClass('active');
              }
          }    
      }  
}


